<div mat-dialog-title>
  <span>{{data.title}}</span>
  <button mat-icon-button (click)="onNoClick()" aria-label="fermer" data-tfa="Annuler">
    <mat-icon data-tfa="cancel">cancel</mat-icon>
  </button>
</div>

<div mat-dialog-content [innerHtml]="data.text"></div>

<div mat-dialog-actions class="dialogButton">
  @for (button of buttons; track button) {
    @if (button.type === buttonTypes.ANNULER) {
      <button mat-raised-button color="primary"
        (click)="onClick(button)"
        [attr.data-tfa]="button.text? button.text: 'Annuler'">
        <mat-icon data-tfa="cancel">cancel</mat-icon>
        <span>{{button.text? button.text: "Annuler"}}</span>
      </button>
    }
    @if (button.type === buttonTypes.CONFIRMER) {
      <button mat-raised-button color="primary"
        (click)="onClick(button)"
        [attr.data-tfa]="button.text? button.text: 'Confirmer'">
        <mat-icon data-tfa="done">done</mat-icon>
        <span>{{button.text? button.text: "Confirmer"}}</span>
      </button>
    }
  }
</div>
